import React from 'react';
import { forEach, groupBy } from 'lodash';
import * as Yup from 'yup';
import { all } from 'axios';

import ReferenceDataProvider from '~/utils/reference-data/context';

import {
  referenceAdminInstance as ReferenceAdmin,
} from '~/utils';

import ReferenceGeneralEventDetailsFieldArray from '~/components/GeneralEvent/ReferenceGeneralEventDetailsFieldArray';

const GeneralEvents = () => (
  <ReferenceDataProvider
    type="ReferenceGeneralEvent"
    config={{
      customFields: {
        referenceGeneralEventDetails: {
          component: ReferenceGeneralEventDetailsFieldArray,
          initialValue: [{
            isActive: true,
            defaultSortOrder: 1,
            generalEventDetailName: '',
            generalEventDetailLabel: '',
            generalEventDetailCode: '',
            generalEventDetailType: undefined,
          }],
          validationSchema: Yup.array().of(Yup.object().shape({
            generalEventDetailName: Yup
              .string()
              .matches(/^[a-zA-Z0-9]+(?:[_ -][a-zA-Z0-9]+)*$/, {
                message: 'Must be alphanumeric characters separated by spaces, underscores, or hyphens. Must not begin or end with a space. No special characters allowed.',
              })
              .required(),
            generalEventDetailLabel: Yup.string().required(),
            generalEventDetailCode: Yup.string().nullable(),
            generalEventDetailType: Yup.mixed().required(),
            defaultSortOrder: Yup.number().required(),
          })).min(1),
        },
      },
      actions: {
        afterRootSubmitSuccess: ({ r, values }) => {
          const promises = [];
          const { referenceGeneralEventDetails } = values;
          const { data: { data } } = r;

          const {
            true: oldItems,
            false: newItems,
          } = groupBy(
            referenceGeneralEventDetails,
            d => !!d.id,
          );

          forEach(oldItems, i =>
            promises.push(ReferenceAdmin
              .put(`reference-general-event-detail/${i.id}`, {
                ...i,
                generalEventUid: data.id,
                generalEventDetailType: i.generalEventDetailType
                  ? i.generalEventDetailType.value
                  : undefined,
              })));

          forEach(newItems, i =>
            promises.push(ReferenceAdmin
              .post('reference-general-event-detail', {
                ...i,
                generalEventUid: data.id,
                generalEventDetailType: i.generalEventDetailType
                  ? i.generalEventDetailType.value
                  : undefined,
              })));

          return all(promises);
        },
      },
    }}
  />
);

export default GeneralEvents;
